
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

interface ErrorDisplayProps {
  error: string | null;
  isQuotaExceeded: boolean;
  isRateLimited: boolean;
  cooldownRemaining: number;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  isQuotaExceeded,
  isRateLimited,
  cooldownRemaining,
}) => {
  if (!error) return null;
  
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription>
        {isQuotaExceeded ? (
          <>
            The AI service has reached its usage limit. This is a temporary issue.
            <br /><br />
            <strong>Try again later when the quota resets.</strong>
          </>
        ) : isRateLimited ? (
          <>
            Too many requests. Please wait {Math.ceil(cooldownRemaining / 1000)} seconds before trying again.
          </>
        ) : (
          error
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ErrorDisplay;
